import { render, staticRenderFns } from "./InventorySlotMax.vue?vue&type=template&id=abb02e9a&"
import script from "./InventorySlotMax.vue?vue&type=script&lang=js&"
export * from "./InventorySlotMax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports